import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import Alert from 'react-s-alert'

import AudienceRecoComponent from './AudienceRecoComponent'
import Spinner from '../Spinner'
import Profile from '../../classes/profile'
import { ANTICIPATION, ANTICIPATION_FILTER, ANTICIPATION_MODULE, FILTER_MODE_MENU, FILTER_MODE_NEW } from '../../constants/commons'
import * as f from '../../classes/Filters'
import GoogleAnalytics from '../../classes/GoogleAnalytics'

export default class AudienceAnticipationComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    location: PropTypes.object.isRequired,
    loadMore: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    programmingFilters: PropTypes.array.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    shortcutPreference: PropTypes.string,
    topicDetails: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }).isRequired,
    topicPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object,
      endOfResult: PropTypes.bool.isRequired,
      planFilters: PropTypes.object.isRequired
    }).isRequired,
    topicPlanAnticipation: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      currentPage: PropTypes.number.isRequired,
      endOfResult: PropTypes.bool.isRequired,
      planFilters: PropTypes.object.isRequired,
      details: PropTypes.object
    }),
    fetchTopicPlan: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.state = {
      topicPlan: this.props.topicPlan
    }
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(ANTICIPATION_MODULE, this.props.location, this.props.profile)
    this.props.resetFilters()
    this.props.setFilters(f.Filters.Common.AnticipationShowMovie, ANTICIPATION_FILTER, ANTICIPATION, FILTER_MODE_NEW)
    setTimeout(() => {
      this.props.fetchTopicPlan(ANTICIPATION, FILTER_MODE_MENU)
    }, 500)
  }

  componentDidUpdate (prevProps) {
    if (this.props.topicDetails.error && !prevProps.topicDetails.error) {
      Alert.error('Error fetching audience, please retry')
    }
    if (this.props.topicPlan.error && !prevProps.topicPlan.error) {
      Alert.error('Error fetching plan, please retry')
    }
    if (!this.props.filters.equals(prevProps.filters)) {
      console.log('new filters', this.props.filters.toString())
      this.setState({
        topicPlan: this.props.topicPlan
      })
    }
    if (this.props.topicPlan !== prevProps.topicPlan) {
      console.log('new plan', this.props.topicPlan)
    }
  }

  render () {
    if (this.props.topicDetails.isFetching) {
      return (<Spinner />)
    }

    return (
      <Row>
        <Container fluid={true} className="rightSideContainer audienceContainer">
          <Row>
            <Col xl={12} lg={12} md={12} sm={12}>
              <AudienceRecoComponent
                topicPlan={this.props.topicPlan}
                loadMore={this.props.loadMore}
                filters={this.props.filters}
                selectedPlanFilters={this.props.selectedPlanFilters}
                programmingFilters={this.props.programmingFilters}
                setFilters={this.props.setFilters}
                resetFilters={this.props.resetFilters}
                location={this.props.location}
                isAnticipation={true}
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                fetchTopicPlan={this.props.fetchTopicPlan}
                />
            </Col>
          </Row>
        </Container>
      </Row>
    )
  }
}
